import { isModifiedClick, navigate } from "../service/Navigation";

/**
 * Uygulama içi link: gerçek <a href> (orta tık / Ctrl+tık yeni sekme, adres kopyalanabilir),
 * düz sol tıkta tam sayfa yüklemesi yerine SPA geçişi. Router dışında (modal içinde) da çalışır.
 * to boşsa tıklanamaz düz <a> çizilir. onClick gezinmeden önce çağrılır.
 */
export default function AppLink({ to, onClick, target, children, ...rest }) {
    if (!to) return <a {...rest}>{children}</a>

    return (
        <a
            {...rest}
            href={to}
            target={target}
            onClick={(e) => {
                onClick && onClick(e)
                if (e.defaultPrevented || target === '_blank' || isModifiedClick(e)) return
                e.preventDefault()
                navigate(to)
            }}
        >
            {children}
        </a>
    )
}
